(function() {
    function initCustomMidCTA(root) {
      if (!root || root.dataset.customMidCtaInitialized === 'true') return;

      const termsCheckbox = root.querySelector('[id^="agree-terms-"]');
      const checkoutBlocker = root.querySelector('[id^="checkout-blocker-"]');
      const shopifyBtnWrapper = root.querySelector('[id^="shopify-buttons-wrapper-"]');
      const errorMsg = root.querySelector('[id^="terms-error-msg-"]');
      const popupTarget = root.querySelector('[data-mid-terms-popup]');
      const widerrufToggle = root.querySelector('[data-mid-widerruf-toggle]');
      const widerrufPanel = root.querySelector('[data-mid-widerruf-panel]');

      if (!termsCheckbox || !checkoutBlocker || !shopifyBtnWrapper) return;

      root.dataset.customMidCtaInitialized = 'true';

      function setCheckoutState() {
        if (termsCheckbox.checked) {
          checkoutBlocker.classList.add('hidden');
          checkoutBlocker.setAttribute('aria-hidden', 'true');
          checkoutBlocker.setAttribute('tabindex', '-1');

          shopifyBtnWrapper.classList.add('active');
          shopifyBtnWrapper.removeAttribute('inert');
          termsCheckbox.setAttribute('aria-invalid', 'false');

          if (errorMsg) {
            errorMsg.style.display = 'none';
          }
        } else {
          checkoutBlocker.classList.remove('hidden');
          checkoutBlocker.setAttribute('aria-hidden', 'false');
          checkoutBlocker.setAttribute('tabindex', '0');

          shopifyBtnWrapper.classList.remove('active');
          shopifyBtnWrapper.setAttribute('inert', '');        }
      }

      function showError(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (errorMsg) {
          errorMsg.style.display = 'block';
        }

        termsCheckbox.setAttribute('aria-invalid', 'true');
        termsCheckbox.style.outline = '2px solid #ef3a12';
        termsCheckbox.style.outlineOffset = '2px';

        if (typeof termsCheckbox.focus === 'function') {
          termsCheckbox.focus({ preventScroll: true });
        }

        setTimeout(function() {
          termsCheckbox.style.outline = 'none';
        }, 1000);
      }

      function setWiderrufPanelState(isOpen) {
        if (!widerrufToggle || !widerrufPanel) return;

        widerrufToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        widerrufPanel.hidden = !isOpen;
        widerrufPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }

      if (widerrufToggle && widerrufPanel) {
        widerrufToggle.addEventListener('click', function() {
          const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
          setWiderrufPanelState(!isOpen);
        });

        widerrufToggle.addEventListener('keydown', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;

          e.preventDefault();
          const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
          setWiderrufPanelState(!isOpen);
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            setWiderrufPanelState(false);
          }
        });

        setWiderrufPanelState(false);
      }

      checkoutBlocker.addEventListener('click', showError);

      checkoutBlocker.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        e.preventDefault();
        e.stopPropagation();
        showError(e);
      });

      termsCheckbox.addEventListener('change', function() {
        setCheckoutState();
      });

      if (popupTarget && popupTarget.dataset.midTermsPopupReady !== 'true') {
        popupTarget.dataset.midTermsPopupReady = 'true';

        const magnifier = popupTarget.querySelector('.mid-terms-magnifier');
        const popup = popupTarget.querySelector('.mid-terms-popup');
        const closeBtn = popupTarget.querySelector('.mid-terms-popup-close');

        function isTouchMode() {
          return window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
        }

        function showMagnifier() {
          popupTarget.classList.add('is-magnifier-visible');

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'false');
          }
        }

        function hideMagnifier() {
          popupTarget.classList.remove('is-magnifier-visible');
        }

        function openPopup(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          popupTarget.classList.add('is-info-active');
          popupTarget.classList.add('is-magnifier-visible');

          if (popup) {
            popup.hidden = false;
          }

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'true');
          }

          if (closeBtn && typeof closeBtn.focus === 'function') {
            closeBtn.focus({ preventScroll: true });
          }
        }

        function closePopup(e, returnFocus) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          popupTarget.classList.remove('is-info-active');

          if (popup) {
            popup.hidden = true;
          }

          if (magnifier) {
            magnifier.setAttribute('aria-expanded', 'false');

            if (returnFocus && typeof magnifier.focus === 'function') {
              magnifier.focus({ preventScroll: true });
            }
          }

          if (isTouchMode()) {
            hideMagnifier();
          }
        }

        function closeAll(returnFocus) {
          closePopup(null, returnFocus);
          hideMagnifier();
        }

        if (magnifier) {
          magnifier.addEventListener('focus', function() {
            showMagnifier();
          });

          magnifier.addEventListener('blur', function() {
            if (!popupTarget.classList.contains('is-info-active')) {
              hideMagnifier();
            }
          });

          magnifier.addEventListener('click', openPopup);

          magnifier.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              openPopup(e);
            }
          });
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            closePopup(e, true);
          });

          closeBtn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              closePopup(e, true);
            }
          });
        }

        if (popup) {
          popup.addEventListener('click', function(e) {
            e.stopPropagation();
          });

          popup.addEventListener('pointerdown', function(e) {
            e.stopPropagation();
          });
        }

        popupTarget.addEventListener('click', function(e) {
          if (!isTouchMode()) return;
          if (e.target.closest('.mid-terms-magnifier')) return;
          if (e.target.closest('.mid-terms-popup')) return;
          if (e.target.closest('a')) return;

          e.preventDefault();
          e.stopPropagation();

          if (popupTarget.classList.contains('is-info-active')) {
            closePopup(null, false);
            return;
          }

          popupTarget.classList.toggle('is-magnifier-visible');
        });

        popupTarget.addEventListener('keydown', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;

          if (document.activeElement === popupTarget) {
            e.preventDefault();
            e.stopPropagation();

            if (popupTarget.classList.contains('is-info-active')) {
              closePopup(null, true);
            } else if (popupTarget.classList.contains('is-magnifier-visible')) {
              openPopup(e);
            } else {
              showMagnifier();
            }
          }
        });

        document.addEventListener('click', function(e) {
          if (!popupTarget.contains(e.target)) {
            closeAll(false);
          }
        });

        document.addEventListener('pointerdown', function(e) {
          if (!popupTarget.contains(e.target)) {
            closeAll(false);
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            closeAll(true);
          }
        });

        window.addEventListener('resize', function() {
          closeAll(false);
        });
      }

      setCheckoutState();
    }

    function initAllCustomMidCTA() {
      document
        .querySelectorAll('[data-custom-mid-cta-section]')
        .forEach(function(root) {
          initCustomMidCTA(root);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCustomMidCTA);
    } else {
      initAllCustomMidCTA();
    }

    document.addEventListener('shopify:section:load', function(event) {
      const root = event.target.querySelector('[data-custom-mid-cta-section]');
      if (root) {
        root.dataset.customMidCtaInitialized = 'false';
        initCustomMidCTA(root);
      }
    });
  })();
